import { localization } from "../localizationManager";

export var portugueseStrings = {
  groupButton: "Agrupar Por Mim",
  ungroupButton: "Desagrupar Por Mim",
  selectButton: "Selecionar",
  hideColumn: "Esconder coluna",
  showColumn: "Mostrar coluna",
  makePrivateColumn: "Tornar coluna privada",
  makePublicColumn: "Tornar coluna pública",
  moveToDetail: "Mover para Detalhes",
  showAsColumn: "Mostrar como Coluna",
  filterPlaceholder: "Pesquisar...",
  removeRows: "Remover linhas",
  showLabel: "Mostrar",
  entriesLabel: "entradas",
  visualizer_text: "Textos em tabela",
  chartType_bar: "Barra",
  chartType_stackedbar: "Barra Empilhada",
  chartType_doughnut: "Rosquinha",
  chartType_pie: "Torta",
  chartType_scatter: "Lastro",
  chartType_gauge: "Escala",
  chartType_bullet: "Bala",
  hideButton: "Esconder",
  makePrivateButton: "Tornar privado",
  makePublicButton: "Tornar público",
  showButton: "Mostrar",
  filter: "Filtrar",
  resetFilter: "Restaurar Filtro",
  changeLocale: "Mudar Localização",
  clearButton: "Limpar",
  addElement: "Escolher questão para mostrar...",
  defaultOrder: "Ordenação Padrão",
  ascOrder: "Ascendente",
  descOrder: "Descendente",
  showMinorColumns: "Mostrar colunas menores",
  otherCommentTitle: "Outros itens e comentários",
  showPercentages: "Mostrar percentuais",
  hidePercentages: "Esconder percentuais",
  saveDiagramAsPNG: "Baixar plot como png",
  hideEmptyAnswers: "Esconder perguntas vazias",
  showEmptyAnswers: "Mostrar perguntas vazias",
  "topNValueText-1": "Todas as respostas",
  "topNValueText5": "Primeiras 5 respostas",
  "topNValueText10": "Primeiras 10 respostas",
  "topNValueText20": "Primeiras 20 respostas",
  noVisualizerForQuestion: "Este tipo de pergunta ainda não foi visualizada",
  noResults: "Ainda não possui resultados"
};

//Uncomment these two lines on creating a translation file. You should replace "en" and enStrings with your locale ("fr", "de" and so on) and your variable.
localization.locales["pt"] = portugueseStrings;
localization.localeNames["pt"] = "Portuguese";
